import { IModem, IProduct } from "../../fetchOrderProducts";

export function isModem(product: IProduct): product is IModem {
  return "specificationId" in product && product.specificationId === "MODEM";
}
